import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Checkbox, FormControlLabel, Grid, Button, Paper, Menu, Typography, Switch } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import * as validatorActions from '../../components/validator/store/actions';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';

const styles = theme => ({
    labelContainer: {
        border: '1px solid',
        borderRadius: '4px',
        borderColor: 'rgba(0, 0, 0, 0.23)',
        "&:hover": {
            borderColor: 'rgba(0, 0, 0, 0.87) !important'
        },
    },
    labelContainerFocus: {
        border: '2px solid',
        borderRadius: '4px',
        borderColor: '#0074D9',
    }
});

const AntSwitch = withStyles(theme => ({
}))(Switch);

class ArrayItemSearch extends Component {

    state = {
        itemSearch: '', focus_active: false, menuOpen: false, selected: []
    }

    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            selected: props.selected ? props.selected : []
        }
    }

    // state = { itemSearch: '', focus_active: false, menuOpen: false, selected: [] }

    handleInputChange = (value) => {
        this.setState({ itemSearch: value });
        if (value.length >= 2) {
            this.setState({ menuOpen: true })
        }
        else {
            this.setState({ menuOpen: false })
        }
    }

    handleItemSelect = (item) => {
        this.setState({ itemSearch: '', focus_active: false, menuOpen: false, selected: this.state.selected.concat([item]) });
        return this.props.updateFilterColumn(this.props.column_id, this.state.selected.concat([item]))
    }

    filteredList = () => {
        const filtered_list = this.props.options.filter(item => !this.state.selected.includes(item));
        return filtered_list.filter(item => !this.state.itemSearch || item.toLowerCase().includes(this.state.itemSearch.toLowerCase()));
    }

    handleItemDelete = (item) => {
        this.setState({ labelSearch: '', focus_active: false, menuOpen: false, selected: this.state.selected.filter(i => i !== item) });
        return this.props.updateFilterColumn(this.props.column_id, this.state.selected.filter(i => i !== item))
    }

    handleSwitchChange = (arg) => {
        this.props.changeArraySwitch(this.props.column_id)
    }

    render() {
        const { classes, theme, component_reference, component_reference_id, baseComponent, updateFunction } = this.props;
        return (
            // <Grid item xs={6}>
            <div style={{ minWidth: '250px' }}>

                <Grid container spacing={0}>
                    <Grid item xs={5}><Typography component="div" variant={'h6'}>{this.props.columnName}</Typography></Grid>
                    <Grid item xs={4}>
                        <Typography component="div">
                            <Grid component="label" container alignItems="center" spacing={0}>
                                <Grid item>All</Grid>
                                <Grid item>
                                    <AntSwitch
                                        checked={this.props.switchVal}
                                        onChange={() => this.handleSwitchChange('checkedC')}
                                        // value="checkedC"
                                    />
                                </Grid>
                                <Grid item>Any</Grid>
                            </Grid>
                        </Typography>
                    </Grid>
                </Grid>

                <div className={this.state.focus_active ? classes.labelContainerFocus : classes.labelContainer}>
                    {this.state.selected.map(item => {
                        return (
                            <Chip key={item} style={{ margin: '5px' }} label={item} onDelete={() => this.handleItemDelete(item)} />
                        )
                    })}
                    <TextField
                        id="itemSearch"
                        style={{ marginLeft: '5px', marginTop: '4px', width: '100%', position: 'static' }}
                        value={this.state.itemSearch}
                        onFocus={() => this.setState({ focus_active: true })}
                        onBlur={() => this.setState({ focus_active: false })}
                        onChange={(e) => this.handleInputChange(e.target.value)}
                        InputProps={{ disableUnderline: true }}
                        autoComplete={'false'}
                    />

                </div>
                {this.state.menuOpen ?
                    <div style={{ maxHeight: '300px', overflowY: 'auto', zIndex: 100, position: 'absolute', width: '95%', border: '1px solid grey'}}>
                        <Paper>
                            <MenuList style={{  }}>
                                {this.filteredList().map(item => {
                                    return (
                                        <MenuItem key={item} onClick={() => this.handleItemSelect(item)}>{item}</MenuItem>
                                    )
                                })}
                            </MenuList>
                        </Paper>
                    </div>
                    : null
                }
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateFilterColumn: Actions.updateFilterColumn,
        changeArraySwitch: Actions.changeArraySwitch
    }, dispatch);
}

function mapStateToProps({ auth, validator }) {
    return {
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ArrayItemSearch)));



// WEBPACK FOOTER //
// src/main/components/tableFilter/ArrayItemSearch.js